import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { IconStatusCheck, IconActionClose } from 'wg-fe-ui';
import { mq } from '../../../../../../../common/src/utils/styledComponentsUtils';
import { useLouiseSelector } from '../../../../../store/redux/store';
import { ToolbarItemStatus } from '../../../types/Sidebar';
import StatusIcon from '../risk-objects/StatusIcon';

interface Props {
  icon: ReactElement;
  isActive?: boolean;
  status?: ToolbarItemStatus;
  onClick?: () => void;
}

const OffersSidebarMobileItem: React.FC<React.PropsWithChildren<Props>> = ({
  isActive,
  status,
  onClick,
  children,
  icon,
}) => {
  const selectedRiskObjects = useLouiseSelector(
    (state) => state.selection.selectedRiskObjects,
  );

  // If number of items is small enough, titles can always be shown
  const alwaysShow = selectedRiskObjects.length <= 2;

  return (
    <NavItem isActive={isActive} onClick={onClick} alwaysShow={alwaysShow}>
      <IconContainer isActive={isActive}>
        {icon}
        {status && (
          <StatusIcon
            status={status}
            show={!(status === 'SKIPPED' && isActive) && status !== undefined}
          >
            {status === 'CHECKED' ? <IconStatusCheck /> : <IconActionClose />}
          </StatusIcon>
        )}
      </IconContainer>
      <TextContainer alwaysShow={alwaysShow} isActive={isActive}>
        <Content>{children}</Content>
      </TextContainer>
    </NavItem>
  );
};

const Content = styled.p`
  word-wrap: break-word;
  hyphens: auto;
  text-align: center;
  color: ${({ theme }) => (theme['isImmo'] ? 'white' : theme.primary[500])};
  display: block;
`;

const TextContainer = styled.div<{ isActive?: boolean; alwaysShow?: boolean }>`
  flex-grow: 1;
  overflow: hidden;
  max-height: 4.5rem;
  display: ${({ alwaysShow }) => (alwaysShow ? 'block' : 'none')};
  transition: 0.2s;
  max-width: ${({ isActive: active }) => (!active ? '0%' : '100%')};
  ${mq.mobileL} {
    display: block;
  }
`;

const NavItem = styled.li<{ isActive?: boolean; alwaysShow?: boolean }>`
  display: flex;
  padding: 0 0.8rem;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: 0.2s;
  height: 45px;
  width: 45px;
  background-color: ${({ theme, isActive: active }) =>
    active
      ? theme['isImmo']
        ? theme.secondary[500]
        : theme.primary[100]
      : '#F0F1F3'};
  border-radius: 9999px;

  flex-grow: ${({ isActive: active, alwaysShow }) =>
    active && alwaysShow ? 1 : 0};

  ${mq.mobileL} {
    flex-grow: ${({ isActive: active }) => (active ? 1 : 0)};
  }
`;

const IconContainer = styled.div<{ isActive?: boolean }>`
  transition: 0.2s;
  > svg {
    width: 25px;
    height: 25px;

    & path {
      fill: ${({ theme, isActive: active }) =>
        active
          ? theme['isImmo']
            ? 'white'
            : theme.primary[500]
          : theme.gray[500]};
      transition: 0.2s;
    }
  }
  ${mq.mobileL} {
    margin-left: ${({ isActive: active }) => active && '0.8rem'};
  }
`;

export default OffersSidebarMobileItem;
